import React, { ReactNode } from 'react';
import { useClasses } from 'app/utils/css';
import {
  NAVIGATION_BACKGROUND_COLOR,
  NAVIGATION_TEXT_COLOR,
} from 'app/constants/Colors';
import { BOX_SHADOW_D } from 'app/constants/Styles';
import { CallbackRef } from 'app/utils/react';

const NAVIGATION_HEIGHT = '50px';

interface IProps {
  children?: ReactNode;
  getRef?: CallbackRef;
}

const SubNav: React.FunctionComponent<IProps> = ({
  children,
  getRef,
}) => {
  const classes = useClasses({
    navigation: {
      display: 'flex',
      backgroundColor: NAVIGATION_BACKGROUND_COLOR,
      height: NAVIGATION_HEIGHT,
      alignItems: 'stretch',
      color: NAVIGATION_TEXT_COLOR,
      position: 'relative',
      boxShadow: BOX_SHADOW_D,
    },
  });

  return (
    <div className={classes.navigation} ref={getRef}>
      {children}
    </div>
  );
};

export default SubNav;
